module.exports = __webpack_public_path__ + "img/g856_rotated.51f948fb.png";